var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvarselstrekant1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10240",
    "data-name": "Group 10240",
    transform: "translate(-1033 -2207)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    y1: 5.218,
    transform: "translate(1041 2212.718)",
    fill: "none",
    stroke: "#e3547b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M1048.5,2222.5h-15l7.5-15Z",
    fill: "none",
    stroke: "#e3547b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M1045.655,2226.327a.828.828,0,0,1-.827.828h0a.828.828,0,0,1-.827-.828h0a.828.828,0,0,1,.827-.827h0a.828.828,0,0,1,.827.827Z",
    transform: "translate(-3.828 -6.317)",
    fill: "#e3547b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvarselstrekant1);
export default __webpack_public_path__ + "static/media/Advarselstrekant 1.7590b63c6f9768efa2988979f8dbb6c0.svg";
export { ForwardRef as ReactComponent };